<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">Lista de Recintos Penitenciarios</h2>
        <p class="text-gray-600 fs-6 fw-bold mb-5">
          <span>
            <button
              type="button"
              class="btn btn-primary px-3"
              @click="newPenitentiary"
            >
              <i title="Ver resolución" class="fas fa-plus"></i> Nuevo ingreso
            </button>
          </span>
        </p>

        <div class="row">
          <DxDataGrid
            id="gridContainer"
            ref="dataGridRef"
            :data-source="penitentiariesList"
            key-expr="id_recinto_penitenciario"
            :allow-column-reordering="false"
            :row-alternation-enabled="true"
            :show-borders="true"
            :column-auto-width="true"
          >
            <!-- Inicio de Complementos para el datatable -->
            <DxFilterRow :visible="true" />
            <DxSearchPanel :visible="true" />
            <DxPaging :page-size="10" />
            <DxPager :visible="true" :show-page-size-selector="true" />
            <!-- <DxGroupPanel :visible="true" /> -->
            <!-- <DxGrouping :auto-expand-all="false" /> -->
            <!-- <DxSelection mode="multiple" /> -->
            <!-- Fin de Complementos para el datatable -->
            <DxColumn
              :width="130"
              :allow-sorting="false"
              caption="Acciones"
              cell-template="cellTemplate"
            />
            <template #cellTemplate="{ data }">
              <button
                type="button"
                class="btn btn-outline-primary"
                title="Editar recinto penitenciario"
                @click="readPenitentiary(data.data.id_recinto_penitenciario)"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                title="Eliminar recinto penitenciario"
                @click="dismissPenitentiary(data.data.id_recinto_penitenciario)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </template>
            <DxColumn
              :width="250"
              :allow-sorting="true"
              caption="Nombre"
              data-field="nombre_recinto_penitenciario"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Departamento"
              data-field="departamento"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Tipo Recinto"
              data-field="tipo_recinto_penitenciario"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Nivel de Seguridad"
              data-field="nivel_seguridad"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Género Poblacional"
              data-field="genero_poblacion"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Capacidad"
              data-field="capacidad"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Provincia"
              data-field="provincia"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Municipio"
              data-field="municipio"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Dirección"
              data-field="direccion"
            />
            <DxColumn
              :width="200"
              :allow-sorting="true"
              caption="Teléfono"
              data-field="telefono"
            />
            <DxColumn
              :width="200"
              :allow-sorting="false"
              caption="Latitud"
              data-field="latitud"
            />
            <DxColumn
              :width="200"
              :allow-sorting="false"
              caption="Longitud"
              data-field="longitud"
            />
          </DxDataGrid>
          <!-- <table class="table">
            <thead>
                <tr>
                    <th>Acciones</th>
                    <th>Nombre</th>
                    <th>Departamento</th>
                    <th>Tipo Centro</th>
                    <th>Nivel de Seguridad</th>
                    <th>Genero Poblacional</th>
                    <th>Capacidad</th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="recinto_penitenciario in penitentiariesList"
                :key="recinto_penitenciario.id_recinto_penitenciario"
                  >
                  <td>
                    <button type="button" class="btn btn-primary btn-sm" @click="readPenitentiary( recinto_penitenciario.id_recinto_penitenciario )">
                      <i title="Editar Recinto Penitenciario" class="fas fa-edit"></i>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" @click="dismissPenitentiary( recinto_penitenciario.id_recinto_penitenciario )">
                      <i title="Eliminar Recinto Penitenciario" class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                  <td>{{ recinto_penitenciario.nombre_recinto_penitenciario }}</td>
                  <td>{{ recinto_penitenciario.departamento }}</td>
                  <td>{{ recinto_penitenciario.tipo_recinto_penitenciario }}</td>
                  <td>{{ recinto_penitenciario.nivel_seguridad }}</td>
                  <td>{{ recinto_penitenciario.genero_poblacion }}</td>
                  <td>{{ recinto_penitenciario.capacidad }}</td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";

import penitentiary from "@/penitentiary/composables/usePenitentiary";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
// import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { locale, loadMessages } from "devextreme/localization";
// import { mapGetters } from 'vuex'
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";

export default defineComponent({
  name: "listPenitentiary",
  components: {
    // Datatable,
    DxDataGrid,
    DxFilterRow,
    DxColumn,
    // DxExport,
    // DxSelection,
    // DxGroupPanel,
    // DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxPager,
    // DxSummary,
    // DxGroupItem,
    // DxSortByGroupSummaryInfo,
    // DxTotalItem,
    // DxSeriesTemplate,
    // DxCommonSeriesSettings,
  },
  // computed: {
  //   ...mapGetters('penitentiary', ['penitentiaryData'])
  // },
  setup() {
    const router = useRouter();

    const penitentiariesList = ref([]);

    const { penitentiaries, infoPenitentiary, deletePenitentiary } =
      penitentiary();

    const newPenitentiary = () => {
      router.push({ name: "readPenitentiary", params: { id: "0" } });
    };

    const listPenitentiaries = async () => {
      const { data } = await penitentiaries();
      const filteredPrisionNames = data.filter(
        (item) => item.nombre_recinto_penitenciario !== "TODOS"
      );
      penitentiariesList.value = filteredPrisionNames;
    };

    const readPenitentiary = async (data) => {
      await infoPenitentiary(data);
      router.push({ name: "readPenitentiary", params: { id: data } });
    };

    const dismissPenitentiary = async (data) => {
      // console.log(data)

      Swal.fire({
        title: "Estas seguro?",
        text: "No se podra revertir el cambio",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si, inhabilitar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // EJECUTAMOS LOS QUERIES
          // console.log('eliminado', data)
          await deletePenitentiary(data);
          Swal.fire(
            "Inhabilitado!",
            "El Recinto Penitenciario fue eliminado.",
            "success"
          );
          await listPenitentiaries();
        }
      });

      // await deletePenitentiary(data)
      // router.go()
      // router.push({ name: "listPenitentiary" });
    };

    onMounted(() => {
      listPenitentiaries();
    });

    // onBeforeMount(() => {
    //     listPenitentiaries();
    // });

    return {
      newPenitentiary,
      listPenitentiaries,
      readPenitentiary,
      dismissPenitentiary,
      penitentiariesList,
    };
  },
});
</script>

<style></style>
